{
  "_leia": "",
  "modoDev": false,
  "mostrarLogConsole": true,
  "mostrarBotaoInfoJanela": true,
  "logarAuth": false,
  "logarSSE": true,
  "preCarga": true,
  "logarSessao": false,
  "logarExtra": false,
  "logarSentencaSQL": false,
  "executarSqlPeriodico": false,
  "garantirColunaNivel": false,
  "suspenderFnFunctionsPeriodicas": false
}
